import { removeFromStorage } from 'ha/utils/storage';
import { Thunk } from 'ha/myredux/types';
import { User } from 'ha/services/apiV2/types/User';
import {
  BILLING_INFO_STORAGE_KEY,
  SHOW_WE_WANT_TO_PAY_STORAGE_KEY,
} from 'ha/modules/WeWantToPay/constants';
import { AuthType } from '../types';
import fetchUserBillingInfo from './fetchUserBillingInfo';
import { AuthLogicActions } from './actions';

const login: (user: User, dialogType: AuthType) => Thunk =
  (user, dialogType) => (dispatch, _, services) =>
    services.apiV2
      .getUserInformation('me', {
        expand:
          'advertiserBookingsCount,savedPaymentMethodsCount,listingsCount,subscriptionFeatures',
      })
      .then(({ data: userInformation }) => {
        dispatch(AuthLogicActions.login(user, userInformation, dialogType));
        removeFromStorage(BILLING_INFO_STORAGE_KEY);
        removeFromStorage(SHOW_WE_WANT_TO_PAY_STORAGE_KEY);
        // do not return this to avoid making form submission invalid if
        // fetching user information fails (which is just to update banner)
        dispatch(fetchUserBillingInfo());
      });

export default login;
